module.exports = __webpack_public_path__ + "static/media/svg.63c13b57.png";